import React from "react";

interface ICustomToggleProps {
  isToggled: boolean;
  label?: string;
  onToggle?: (value: boolean) => void;
  disabled?: boolean;
}

const CustomToggle: React.FC<ICustomToggleProps> = ({
  isToggled,
  label = "",
  onToggle,
  disabled = false,
}) => {
  return (
    <label className="inline-flex items-center me-5 cursor-pointer">
      <span className="text-sm font-normal text-gray-500 dark:text-gray-300 mr-3">
        {label}
      </span>
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={isToggled}
        onChange={(e) => onToggle && onToggle(e.target.checked)}
        disabled={disabled}
      />
      <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
    </label>
  );
};

export default CustomToggle;
